/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { ServiceTransactionLogDto } from '../model/serviceTransactionLogDto';
import { ServiceTransactionLogDtoPaginatedItemsViewModel } from '../model/serviceTransactionLogDtoPaginatedItemsViewModel';
import { ServiceTransactionSummary } from '../model/serviceTransactionSummary';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceTransactionLogsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param resourceId 
     * @param clientId 
     * @param channel 
     * @param dateFrom 
     * @param dateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceTransactionLogDto>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceTransactionLogDto>>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceTransactionLogDto>>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }
        if (channel !== undefined && channel !== null) {
            queryParameters = queryParameters.set('channel', <any>channel);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceTransactionLogDto>>('get',`${this.basePath}/api/ServiceTransactionLogs/GetAllServiceTransactionsLogsByServiceIdDateRangeAndChannel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param weeklyInterval 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsForPreviousMonthByServiceIdGet(serviceId?: string, weeklyInterval?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceTransactionSummary>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsForPreviousMonthByServiceIdGet(serviceId?: string, weeklyInterval?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceTransactionSummary>>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsForPreviousMonthByServiceIdGet(serviceId?: string, weeklyInterval?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceTransactionSummary>>>;
    public apiServiceTransactionLogsGetAllServiceTransactionsLogsForPreviousMonthByServiceIdGet(serviceId?: string, weeklyInterval?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (weeklyInterval !== undefined && weeklyInterval !== null) {
            queryParameters = queryParameters.set('weeklyInterval', <any>weeklyInterval);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceTransactionSummary>>('get',`${this.basePath}/api/ServiceTransactionLogs/GetAllServiceTransactionsLogsForPreviousMonthByServiceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param clientId 
     * @param channel 
     * @param dateFrom 
     * @param dateTo 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceTransactionLogsGetServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ServiceTransactionLogDtoPaginatedItemsViewModel>;
    public apiServiceTransactionLogsGetServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceTransactionLogDtoPaginatedItemsViewModel>>;
    public apiServiceTransactionLogsGetServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceTransactionLogDtoPaginatedItemsViewModel>>;
    public apiServiceTransactionLogsGetServiceTransactionsLogsByServiceIdDateRangeAndChannelGet(resourceId?: string, clientId?: string, channel?: string, dateFrom?: Date, dateTo?: Date, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }
        if (channel !== undefined && channel !== null) {
            queryParameters = queryParameters.set('channel', <any>channel);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceTransactionLogDtoPaginatedItemsViewModel>('get',`${this.basePath}/api/ServiceTransactionLogs/GetServiceTransactionsLogsByServiceIdDateRangeAndChannel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
